module.exports = __webpack_public_path__ + "img/room07_emoji.fdeeb400.png";